import React from 'react';
import PropTypes from 'prop-types';

/**
 * SelectRate
 */
class SelectRate extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedOption: props.data.rate, // 初期状態を設定
    };
    this.handleOptionChange = this.handleOptionChange.bind(this);
  }

  // このボックスの表示データを取得
  componentDidMount() {
    this.props.comactions.onMountedRate();
  }

  handleOptionChange(event) {
    this.setState({ selectedOption: event.target.value });
    this.props.actions.changeRate(event.target.value);
  }

  render() {
    let itemList = [];
    // 表示データを取得
    if (this.props.data.pskubun == 1) {
      itemList = this.props.data.itemList.rateList['slotList'];
    } else {
      itemList = this.props.data.itemList.rateList['pachinkoList'];
    }

    const defaultValue = this.props.data.rate;

    // 表示データを生成
    const nodeList = [];
    itemList.map((item) => {
      nodeList.push(
        <input type="radio" id={item.id} value={item.id} checked={defaultValue == item.id} onChange={this.handleOptionChange} key={'input-' + item.id} />
      );
      nodeList.push(
        <label htmlFor={item.id} className={defaultValue == item.id ? 'switch-on' : 'switch-off'} key={'label-' + item.id} >{item.display_name}</label>
      );
    });

    return (
      <div>
        <div id="switchRate" className="switchPs switchPs-and-rate-size">
          {nodeList}
        </div>
      </div>
    );
  }
}

SelectRate.propTypes = {
  actions: PropTypes.any.isRequired,
  comactions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired,
};

export default SelectRate;
